import {
	AppBar,
	Checkbox,
	CircularProgress,
	createTheme,
	Dialog,
	DialogContent,
	FormControl,
	IconButton,
	InputLabel,
	Link,
	MenuItem,
	Paper,
	Select,
	Slide,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Toolbar,
	Typography,
	useMediaQuery,
} from "@mui/material"
import { forwardRef, useContext, useEffect, useState } from "react"
import { AdminContext } from "../views/Admin"
import CloseIcon from "@mui/icons-material/Close"
import { extDoSearchPriceListV2 } from "../util/firebase"

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />
})

const mdTheme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
		white: {
			main: "white",
		},
	},
})

const PriceSearchDialog = () => {
	const adminContext = useContext(AdminContext)
	const priceSearchOpen = adminContext.priceSearchOpen
	const setPriceSearchOpen = adminContext.setPriceSearchOpen

	const setPostPriceScoreMax = adminContext.setPostPriceScoreMax
	const setPostPriceScoreMin = adminContext.setPostPriceScoreMin
	const setPostPriceScoreValues = adminContext.setPostPriceScoreValues
	const post = adminContext.post

	const matches = useMediaQuery(mdTheme.breakpoints.up("md"))

	const [makeFilter, setMakeFilter] = useState("")
	const [modelFilter, setModelFilter] = useState("")
	const [submodelFilter, setSubmodelFilter] = useState("")
	const [yearFilter, setYearFilter] = useState("")
	const [makeOptions, setMakeOptions] = useState([])
	const [modelOptions, setModelOptions] = useState([])
	const [submodelOptions, setSubmodelOptions] = useState([])
	const [yearOptions, setYearOptions] = useState([])
	const [results, setResults] = useState([])
	const [loading, setLoading] = useState(false)
	/* const [noFilters, setNoFilters] = useState(true) */

	const [checkedAds, setCheckedAds] = useState([])

	const handleMakeFilter = (e) => {
		setMakeFilter(e.target.value)
	}
	const handleModelFilter = (e) => {
		setModelFilter(e.target.value === "~איפוס~" ? "" : e.target.value)
	}
	const handleSubmodelFilter = (e) => {
		setSubmodelFilter(e.target.value === "~איפוס~" ? "" : e.target.value)
	}
	const handleYearFilter = (e) => {
		setYearFilter(e.target.value === "~איפוס~" ? "" : e.target.value)
	}

	const handleResetFilters = async () => {
		setMakeFilter("")
		setModelFilter("")
		setSubmodelFilter("")
		setYearFilter("")
		setCheckedAds([])
	}

	const handleSaveToPost = () => {
		const _priceScoreValues = results.filter((result) => checkedAds.indexOf(result.id.raw) > -1)
		console.log(_priceScoreValues)
		setPostPriceScoreMin(_priceScoreValues[0].price.raw)
		setPostPriceScoreMax(_priceScoreValues[_priceScoreValues.length - 1].price.raw)
		const _newPriceScoreValues = _priceScoreValues.map((result) => {
			let _handtext = ""
			switch (result.handtext.raw) {
				case "יד ראשונה":
					_handtext = "1"
					break
				case "יד שניה":
					_handtext = "2"
					break
				case "יד שלישית":
					_handtext = "3"
					break
				case "יד רביעית":
					_handtext = "4"
					break
				case "יד חמישית":
					_handtext = "5"
					break
				case "יד שישית":
					_handtext = "6"
					break
				case "יד שביעית":
					_handtext = "7"
					break
				case "יד שמינית":
					_handtext = "8"
					break
				case "יד תשיעית":
					_handtext = "9"
					break
				case "יד עשירית ויותר":
					_handtext = "10"
					break
				case "מיבואן":
					_handtext = "0"
					break
				default:
					break
			}
			return {
				...result,
				handtext: { raw: _handtext },
			}
		})
		setPostPriceScoreValues(
			_newPriceScoreValues.map((result) => ({
				price: result.price.raw,
				previousOwners: result.handtext.raw,
				date: result.dateadded.raw,
			}))
		)
		handleResetFilters()
		setPriceSearchOpen(false)
	}

	const _doSearchPriceList = async () => {
		let newFilters = { all: [] }
		if (makeFilter.length > 0) newFilters.all.push({ manufacturer: makeFilter })
		if (modelFilter.length > 0) newFilters.all.push({ rowone: modelFilter })
		if (submodelFilter.length > 0) newFilters.all.push({ rowtwo: submodelFilter })
		if (yearFilter.length > 0) newFilters.all.push({ year: parseInt(yearFilter) })

		setCheckedAds([])
		setLoading(true)
		const response = await extDoSearchPriceListV2({ filters: newFilters })
		if (response.data?.facets?.manufacturer && makeOptions.length === 0)
			setMakeOptions(response.data?.facets?.manufacturer[0].data.map((make) => make.value))
		if (response.data?.facets?.rowone)
			setModelOptions(response.data?.facets?.rowone[0].data.map((model) => model.value))
		if (response.data?.facets?.rowtwo)
			setSubmodelOptions(response.data?.facets?.rowtwo[0].data.map((model) => model.value))
		if (response.data?.facets?.year)
			setYearOptions(response.data?.facets?.year[0].data.map((model) => model.value.toString()))

		if (newFilters.all.length > 0) {
			setResults(response.data?.results)
		} else {
			setResults([])
		}
		setLoading(false)
	}

	useEffect(() => {
		_doSearchPriceList()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [makeFilter, modelFilter, submodelFilter, yearFilter])

	const handleCheckboxChange = (e, id) => {
		if (e.target.checked) {
			setCheckedAds((prevState) => [...prevState, id])
		} else {
			setCheckedAds((prevState) => prevState.filter((element) => element !== id))
		}
	}

	/* useEffect(() => {
		console.log(checkedAds)
	}, [checkedAds]) */

	return (
		<Dialog
			fullScreen={!matches}
			open={priceSearchOpen}
			onClose={() => {
				setCheckedAds([])
				setPriceSearchOpen(false)
			}}
			TransitionComponent={Transition}
			PaperProps={{
				style: {
					backgroundColor: "#ff7101",
					maxHeight: "715px",
				},
			}}
			maxWidth={"md"}
			/* scroll="body" */
			/* sx={{ maxHeight: "715px"}} */
		>
			<AppBar sx={{ position: "relative" }}>
				<Toolbar>
					<IconButton
						edge="start"
						color="inherit"
						onClick={() => {
							setCheckedAds([])
							setPriceSearchOpen(false)
						}}
						aria-label="close"
					>
						<CloseIcon />
					</IconButton>
					<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
						חיפוש מחירים היסטורי
					</Typography>
				</Toolbar>
			</AppBar>
			<DialogContent dividers>
				<Paper sx={{ p: 2, display: "flex", flexDirection: matches ? "row" : "column" /* , height: "100%" */ }}>
					<FormControl sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} size="small">
						<InputLabel>יצרן</InputLabel>
						<Select
							/* sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} */
							size="small"
							value={makeFilter}
							label="יצרן"
							onChange={handleMakeFilter}
						>
							{makeOptions.map((key) => (
								<MenuItem key={key} value={key}>
									{key}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} size="small">
						<InputLabel>דגם</InputLabel>
						<Select
							/* sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} */
							size="small"
							value={modelFilter}
							label="דגם"
							onChange={handleModelFilter}
						>
							{["~איפוס~", ...modelOptions].map((key) => (
								<MenuItem key={key} value={key}>
									{key}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} size="small">
						<InputLabel>תת-דגם</InputLabel>
						<Select
							/* sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} */
							size="small"
							value={submodelFilter}
							label="תת-דגם"
							onChange={handleSubmodelFilter}
						>
							{["~איפוס~", ...submodelOptions].map((key) => (
								<MenuItem key={key} value={key}>
									{key}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} size="small">
						<InputLabel>שנה</InputLabel>
						<Select
							/* sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} */
							size="small"
							value={yearFilter}
							label="שנה"
							onChange={handleYearFilter}
						>
							{["~איפוס~", ...yearOptions].map((key) => (
								<MenuItem key={key} value={key}>
									{key}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<Link sx={{ cursor: "pointer" }} onClick={handleResetFilters}>
						איפוס
					</Link>
				</Paper>
				<Paper
					sx={{
						mt: 2,
						p: 2,
						display: "flex",
						justifyContent: "center",
						/* flexDirection: matches ? "row" : "column", */
						flexDirection: "column",
						alignItems: "center",
					}}
				>
					{loading && <CircularProgress color="primary" />}
					{!matches &&
						!loading &&
						results.length > 0 &&
						results.map((result, index) => (
							<Paper sx={{ p: 2, mb: 2, backgroundColor: "#BFDDFF" }} key={result.id.raw}>
								<Table sx={{ tableLayout: "fixed" }}>
									<TableBody>
										{[
											{ field: "kilometers", label: 'ק"מ' },
											{ field: "dateadded", label: 'ת. מודעה' },
											{ field: "handtext", label: "יד" },
											{ field: "pricelistlinkurl", label: "מחירון יד2" },
											{ field: "price", label: "מחיר" },
											{ field: "checked", label: "בחירה" },
										].map((col) => (
											<TableRow
												key={col.field}
												sx={{ backgroundColor: checkedAds.indexOf(result.id.raw) > -1 ? "lightsalmon" : "white" }}
											>
												<TableCell variant="head" sx={{ fontWeight: 600 }}>
													{col.label}
												</TableCell>
												<TableCell>
													{col.field === "checked" && (
														<Checkbox
															/* checked={checked} */
															onChange={(e) => handleCheckboxChange(e, result.id.raw)}
														/>
													)}
													{col.field === "kilometers" && <>{result.kilometers.raw}</>}
													{col.field === "dateadded" && <>{new Date(result.dateadded.raw).toLocaleDateString("he")}</>}
													{col.field === "handtext" && <>{result.handtext.raw}</>}
													{col.field === "pricelistlinkurl" && (
														<Link href={result.pricelistlinkurl.raw} target="_blank">
															מחירון
														</Link>
													)}
													{col.field === "price" &&
														"\u20aa" + new Intl.NumberFormat().format(parseInt(result.price.raw))}
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</Paper>
						))}
					{!matches && !loading && results.length > 0 && (
						<>
							<Table sx={{ tableLayout: "fixed" }}>
								<TableBody>
									<TableRow>
										<TableCell variant="head" sx={{ fontWeight: 600 }}>
											ממוצע
										</TableCell>
										<TableCell>
											{"\u20aa" +
												new Intl.NumberFormat().format(
													parseInt(results.reduce((acc, result) => acc + result.price.raw, 0) / results.length)
												)}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
							{post && (
								<Link sx={{ cursor: "pointer", color: mdTheme.palette.secondary.main }} onClick={handleSaveToPost}>
									השתמש בנתונים אלה למודעה
								</Link>
							)}
						</>
					)}
					{matches && !loading && results.length > 0 && (
						<>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell variant="head" sx={{ fontWeight: 600 }}>
											בחירה
										</TableCell>
										<TableCell variant="head" sx={{ fontWeight: 600 }}>
											ק"מ
										</TableCell>
										<TableCell variant="head" sx={{ fontWeight: 600 }}>
											ת. מודעה
										</TableCell>
										<TableCell variant="head" sx={{ fontWeight: 600 }}>
											יד
										</TableCell>
										<TableCell variant="head" sx={{ fontWeight: 600 }}>
											מחירון יד2
										</TableCell>
										<TableCell variant="head" sx={{ fontWeight: 600 }}>
											מחיר
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{results.map((result, index) => (
										<TableRow
											key={result.id.raw}
											/* sx={{ backgroundColor: filterArray.indexOf(doc.fileName) > -1 ? "pink" : "#BFDDFF" }} */
											sx={{ backgroundColor: checkedAds.indexOf(result.id.raw) > -1 ? "lightsalmon" : "white" }}
										>
											<TableCell>
												<Checkbox
													/* checked={checked} */
													onChange={(e) => handleCheckboxChange(e, result.id.raw)}
												/>
											</TableCell>
											<TableCell>{result.kilometers.raw}</TableCell>
											<TableCell>{new Date(result.dateadded.raw).toLocaleDateString("he")}</TableCell>
											<TableCell>{result.handtext.raw}</TableCell>
											<TableCell>
												<Link href={result.pricelistlinkurl?.raw} target="_blank">
													מחירון
												</Link>
											</TableCell>
											<TableCell>{"\u20aa" + new Intl.NumberFormat().format(parseInt(result.price.raw))}</TableCell>
										</TableRow>
									))}
									<TableRow>
										<TableCell colSpan={3} sx={{ fontWeight: "600" }}>
											ממוצע
										</TableCell>
										<TableCell>
											{"\u20aa" +
												new Intl.NumberFormat().format(
													parseInt(results.reduce((acc, result) => acc + result.price.raw, 0) / results.length)
												)}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
							{post && (
								<Link sx={{ cursor: "pointer", color: mdTheme.palette.secondary.main }} onClick={handleSaveToPost}>
									השתמש בנתונים אלה למודעה
								</Link>
							)}
						</>
					)}
				</Paper>
			</DialogContent>
		</Dialog>
	)
}

export default PriceSearchDialog
